import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { useState, useRef, useEffect, useMemo } from "react";
import { Typography, Box } from "@mui/material";
import "lottie-react";
import "../../../../../themes/shadows/shadows.js";
import "../../../../../themes/typography/typography.js";
import "../../../../../components/avatar-group/avatar-group.styles.js";
import "../../../../../components/date-pickers/pickers-action-bar/pickers-action-bar.js";
import "../../../../../components/date-pickers/date-picker/theme/index.js";
import "../../../../../components/dialog/dialog.js";
import "../../../../../components/icons/all/all.js";
import "../../../../../components/label/label.styles.js";
import { MenuItem } from "../../../../../components/menu-item/menu-item.js";
import "../../../../../components/slider/slider.styles.js";
import "@mui/material/styles";
import "../../../../../components/snackbar/snackbar.styles.js";
import "../../../../../components/styled-text-field/styled-text-field.styles.js";
import "../../../../../components/swipeable-drawer/swipeable-drawer.js";
import "../../../../../components/translations/utils.js";
import "../../../../../components/time-select/time-select.styles.js";
import "../../../../../components/time-interval-select/time-interval-select.styles.js";
import { ExpandMoreIcon } from "../../../../components/appointments-picker/appointments-picker.styles.js";
import { useLocalStorageProperly } from "../../../../../hooks/useLocalStorageProperly.js";
import { flow, debounce } from "lodash";
import { Role } from "../../types/practitioner.js";
import { PractitionerSearch } from "./components/practitioner-search.js";
import { DropdownButton, practitionersIcon, ArrowIcon, SearchMenu, Accordion, AccordionSummary, StatusTitle, StatusCount, AccordionDetails, SearchDivider, RoleCount } from "./practitioner-select.styles.js";
import "../../../../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../../../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "@mui/system";
import "@mui/material/Button/index.js";
import "@mui/x-date-pickers/internals/index.js";
import "../../../../../constants/create-theme/create-theme.js";
import "../../../../../constants/colors/palette.js";
import "../../../../../themes/button/button.js";
import "../../../../../themes/button/styles/external/bordered.styles.js";
import "color-alpha";
import "../../../../../themes/button/styles/external/filled.styles.js";
import "../../../../../themes/button/styles/internal/bordered.styles.js";
import "../../../../../themes/button/styles/internal/borderless.styles.js";
import "../../../../../themes/button/styles/internal/filled.styles.js";
import "../../../../../themes/button/styles/internal/shadowed.styles.js";
import "../../../../../components/date-pickers/pickers-action-bar/pickers-action-bar.styles.js";
import "../../../../../themes/date-calendar/date-calendar.js";
import "../../../../../themes/date-picker-toolbar/date-picker-toolbar.js";
import "../../../../../themes/day-calendar/day-calendar.js";
import "../../../../../themes/filled-input/filled-input.js";
import "../../../../../themes/form-helper-text/form-helper-text.js";
import "../../../../../themes/form-label/form-label.js";
import "../../../../../themes/month-calendar/month-calendar.js";
import "../../../../../themes/pickers-arrow-switcher/pickers-arrow-switcher.js";
import "../../../../../themes/pickers-calendar-header/pickers-calendar-header.js";
import "../../../../../themes/pickers-day/pickers-day.js";
import "@mui/x-date-pickers";
import "../../../../../themes/pickers-month/pickers-month.js";
import "../../../../../themes/pickers-popper/pickers-popper.js";
import "../../../../../themes/pickers-toolbar/pickers-toolbar.js";
import "../../../../../themes/pickers-year/pickers-year.js";
import "../../../../../themes/year-calendar/year-calendar.js";
import "@mui/icons-material/Close.js";
import "../../../../../themes/alert/alert.js";
import "../../../../../themes/alert/components/ErrorIcon/ErrorIcon.js";
import "@mui/material/SvgIcon/index.js";
import "../../../../../themes/alert/components/InfoIcon/InfoIcon.js";
import "../../../../../themes/alert/components/SuccessIcon/SuccessIcon.js";
import "../../../../../themes/alert/components/WarningIcon/WarningIcon.js";
import "../../../../../themes/dialog/dialog.js";
import "../../../../../themes/external-theme/external-theme.js";
import "../../../../../constants/breakpoints/breakpoints.js";
import "../../../../../themes/checkbox/checkbox.js";
import "../../../../../themes/checkbox/components/CheckedIcon/CheckedIcon.js";
import "../../../../../themes/checkbox/components/IndeterminateIcon/IndeterminateIcon.js";
import "../../../../../themes/form-control-label/form-control-label.js";
import "../../../../../themes/radio/radio.js";
import "../../../../../themes/switch/switch.js";
import "../../../../../themes/popover/popover.js";
import "../../../../../themes/tooltip/tooltip.js";
import "../../../../../components/dialog/dialog.constants.js";
import "../../../../../components/dialog/dialog.styles.js";
import "@emotion/react";
import "../../../../../components/dialog/DraggablePaperComponent.js";
import "react-draggable";
import "../../../../../components/icons/CalendarEventIcon/CalendarEventIcon.js";
import "../../../../../components/icons/MainIcon/MainIcon.js";
import "../../../../../components/icons/CalendarIcon/CalendarIcon.js";
import "../../../../../components/icons/CardIcon/CardIcon.js";
import "../../../../../components/icons/ChecklistIcon/ChecklistIcon.js";
import "../../../../../components/icons/ClockIcon/ClockIcon.js";
import "../../../../../components/icons/CloseIcon/CloseIcon.js";
import "../../../../../components/icons/EditIcon/EditIcon.js";
import "../../../../../components/icons/EmptyCalendar/EmptyCalendar.js";
import "../../../../../components/icons/EventNote/EventNote.js";
import "../../../../../components/icons/FilterIcon/FilterIcon.js";
import "../../../../../components/icons/ListIcon/ListIcon.js";
import "../../../../../components/icons/MessageBubble/MessageBubble.js";
import "../../../../../components/icons/PhoneIcon/PhoneIcon.js";
import "../../../../../components/icons/PinIcon/PinIcon.js";
import "../../../../../components/icons/SearchIcon/SearchIcon.js";
import "../../../../../components/icons/TherapyNotesIcon/TherapyNotesIcon.js";
import "../../../../../components/icons/TimerIcon/TimerIcon.js";
import "../../../../../components/icons/TreatmentChairIcon/TreatmentIcon.js";
import "../../../../../components/icons/VisibilityOffIcon/VisibilityOffIcon.js";
import "../../../../../components/icons/WarningIcon/WarningIcon.js";
import "@mui/material/MenuItem/index.js";
import "../../../../../components/menu-item/components/menu-item-counter/menu-item-counter.js";
import "../../../../../components/menu-item/assets/icons/minus-circle.js";
import "../../../../../components/menu-item/assets/icons/plus-circle.js";
import "../../../../../components/menu-item/components/menu-item-counter/menu-item-counter.styles.js";
import "../../../../../components/menu-item/menu-item.styles.js";
import "../../../../../components/avatar/avatar.js";
import "@mui/material/Avatar/index.js";
import "../../../../../components/avatar/avatar.styles.js";
import "@mui/material/Snackbar/index.js";
import "../../../../../components/snackbar/snackbar.types.js";
import "../../../../../components/text-field/text-field.js";
import "@mui/material/TextField/index.js";
import "../../../../../components/text-field/text-field.styles.js";
import "../../../../../components/swipeable-drawer/swipeable-drawer.styles.js";
import "react-i18next";
import "../../../../../type/Translations.js";
import "contentful";
import "i18next";
import "lodash/set.js";
import "remarkable";
import "remarkable-react";
import "@mui/icons-material/Timer.js";
import "@mui/material/FormControl/index.js";
import "@mui/material/InputLabel/index.js";
import "@mui/material/Select/index.js";
import "@mui/material/Box/index.js";
import "@mui/icons-material/ArrowBackIos.js";
import "@mui/icons-material/ExpandMore.js";
import "@mui/material/Card/index.js";
import "@mui/material/CardContent/index.js";
import "./components/practitioner-search.styles.js";
import "./components/assets/Search.js";
import "./assets/icons/Arrow.js";
import "./assets/icons/Employees.js";
const getIsAllPractitionersSelected = (practitioners) => practitioners.filter(({ hidden }) => !hidden).every(({ isSelected }) => isSelected);
const getPractitionersSelectedCount = (practitioners) => practitioners.filter(({ isSelected }) => isSelected).length;
const getStatusSelectedCount = (statuses) => statuses.filter(({ isSelected }) => isSelected).length;
const practitionersGroupedByRole = (practitioners) => {
  const roleMap = {};
  const collator = new Intl.Collator("de", {
    ignorePunctuation: true
  });
  practitioners.forEach((practitioner) => {
    const practitionerPositions = practitioner.practitionerPositions;
    if (practitionerPositions && practitionerPositions.length === 0) {
      return;
    }
    practitionerPositions == null ? void 0 : practitionerPositions.forEach((position) => {
      const role = position.role;
      if (![Role.DENTIST, Role.HYGIENIST].includes(role)) {
        return;
      }
      if (!roleMap[role]) {
        roleMap[role] = { roleName: role, practitioners: [] };
      }
      roleMap[role].practitioners.push(practitioner);
      roleMap[role].practitioners.sort((a, b) => collator.compare(a.avatar.userName ?? "", b.avatar.userName ?? ""));
    });
  });
  return Object.values(roleMap).reverse();
};
const getDeactivated = (practitioners) => {
  const inactivePractitioners = practitioners.filter(({ active }) => !active);
  const hasDeactivated = !!inactivePractitioners.length;
  const isSwitched = inactivePractitioners.length ? inactivePractitioners.every(({ isSelected }) => isSelected) : false;
  return { isSwitched, hasDeactivated };
};
const getResultsFromPractitionerSearch = (practitioners, searchValue) => {
  return practitioners.filter((item) => {
    const lowerCaseSearchTerm = searchValue.toLowerCase();
    if (!item.avatar.userName) {
      return false;
    }
    return item.avatar.userName.toLowerCase().indexOf(lowerCaseSearchTerm) !== -1;
  });
};
const getPractitionersToRender = flow(getResultsFromPractitionerSearch, practitionersGroupedByRole);
const PractitionerSelect = ({
  clinicReferenceId,
  onPractitionerUpdate,
  onStatusUpdate,
  practitioners,
  labels,
  selectedStatuses
}) => {
  const [showFilters, setShowFilters] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [searchValue, setSearchValue] = useLocalStorageProperly(
    `${clinicReferenceId}_PractitionerSelectSearchValue`,
    ""
  );
  const anchorElement = useRef(null);
  useEffect(() => {
    setShowFilters(!searchValue);
  }, [searchValue]);
  const { isSwitched: isDeactivatedSwitched, hasDeactivated } = getDeactivated(practitioners);
  const isAllPractitionersSelected = getIsAllPractitionersSelected(practitioners);
  const noSearchResults = !practitioners.length;
  const practitionersToRender = getPractitionersToRender(practitioners, searchValue ? searchValue : "");
  const statusSelectedCount = getStatusSelectedCount(selectedStatuses);
  const practitionersSelectedCount = useMemo(() => {
    const filteredPractitioners = practitioners.filter(
      ({ practitionerPositions }) => practitionerPositions.some(({ role }) => [Role.DENTIST, Role.HYGIENIST].includes(role))
    );
    return getPractitionersSelectedCount(filteredPractitioners);
  }, [practitioners]);
  const handleSearch = debounce((searchValue2) => {
    setSearchValue(searchValue2);
  }, 300);
  const handleAllSwitch = (isSwitched) => {
    const practitionersUpdated = practitioners.map((item) => {
      return { ...item, isSelected: item.active ? !isSwitched : item.isSelected };
    });
    onPractitionerUpdate(practitionersUpdated);
  };
  const handleRoleSwitch = (roleName, areAllSelected) => {
    const practitionersUpdated = practitioners.map((item) => {
      const roleMatched = item.practitionerPositions.some((item2) => item2.role === roleName);
      return roleMatched ? { ...item, isSelected: !areAllSelected } : item;
    });
    onPractitionerUpdate(practitionersUpdated);
  };
  const handleDeactivatedSwitchAndSelect = () => {
    const practitionersUpdated = practitioners.map((item) => {
      if (!item.active) {
        return {
          ...item,
          hidden: !isDeactivatedSwitched ? false : !item.active,
          isSelected: !isDeactivatedSwitched
        };
      }
      return {
        ...item,
        hidden: !isDeactivatedSwitched ? false : !item.active
      };
    });
    onPractitionerUpdate(practitionersUpdated);
  };
  const handlePractitionerSelect = (practitioner) => {
    const selectedPractitionerId = practitioner.id;
    const practitionersUpdated = practitioners.map(
      (item) => item.id === selectedPractitionerId ? { ...practitioner, isSelected: !practitioner.isSelected } : item
    );
    onPractitionerUpdate(practitionersUpdated);
  };
  const handleStatusSelect = (status) => {
    const selectedStatusLabel = status.status;
    const statuses = selectedStatuses == null ? void 0 : selectedStatuses.map((status2) => {
      if (status2.status === selectedStatusLabel) {
        return {
          ...status2,
          isSelected: !status2.isSelected
        };
      }
      return status2;
    });
    onStatusUpdate(statuses);
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      DropdownButton,
      {
        onClick: () => {
          setIsOpen((prev) => !prev);
        },
        isOpen,
        variant: "bordered",
        startIcon: /* @__PURE__ */ jsx(practitionersIcon, {}),
        endIcon: /* @__PURE__ */ jsx(ArrowIcon, { isOpen }),
        size: "sm",
        fullWidth: false,
        ref: anchorElement,
        children: /* @__PURE__ */ jsx(Typography, { variant: "Lato Overline Bold", align: "center", children: labels.title })
      }
    ),
    /* @__PURE__ */ jsx(
      SearchMenu,
      {
        maxHeight: 560,
        open: isOpen,
        anchorEl: anchorElement == null ? void 0 : anchorElement.current,
        onClose: () => setIsOpen(false),
        disableScrollLock: true,
        keepMounted: true,
        width: 300,
        anchorOrigin: {
          horizontal: "left",
          vertical: "bottom"
        },
        children: /* @__PURE__ */ jsxs("div", { children: [
          /* @__PURE__ */ jsxs(Accordion, { children: [
            /* @__PURE__ */ jsxs(AccordionSummary, { expandIcon: /* @__PURE__ */ jsx(ExpandMoreIcon, {}), "aria-controls": "panel1-content", id: "panel1-header", children: [
              /* @__PURE__ */ jsx(StatusTitle, { variant: "Lato Emphasized 1", children: labels.statuses.titles.practitioners }),
              " ",
              practitionersSelectedCount ? /* @__PURE__ */ jsx(StatusCount, { variant: "Lato Caption Bold", children: practitionersSelectedCount }) : null
            ] }),
            /* @__PURE__ */ jsxs(AccordionDetails, { children: [
              /* @__PURE__ */ jsx(
                PractitionerSearch,
                {
                  onSearch: handleSearch,
                  placeholder: labels.search,
                  clinicReferenceId
                }
              ),
              /* @__PURE__ */ jsxs("div", { children: [
                showFilters && /* @__PURE__ */ jsx(
                  MenuItem,
                  {
                    variant: "switch",
                    selected: isAllPractitionersSelected,
                    onClick: () => handleAllSwitch(isAllPractitionersSelected),
                    size: "s",
                    children: labels.toggles.ALL
                  }
                ),
                showFilters && practitionersGroupedByRole(practitioners).map(({ practitioners: practitioners2, roleName }) => {
                  const isAllSelected = getIsAllPractitionersSelected(practitioners2);
                  return /* @__PURE__ */ jsx(
                    MenuItem,
                    {
                      onClick: () => handleRoleSwitch(roleName, isAllSelected),
                      variant: "switch",
                      selected: isAllSelected,
                      size: "s",
                      children: labels.toggles[roleName]
                    },
                    roleName
                  );
                }),
                hasDeactivated && /* @__PURE__ */ jsx(
                  MenuItem,
                  {
                    onClick: handleDeactivatedSwitchAndSelect,
                    variant: "switch",
                    selected: isDeactivatedSwitched,
                    size: "s",
                    children: labels.toggles.DEACTIVATED
                  }
                ),
                noSearchResults && /* @__PURE__ */ jsx(Typography, { variant: "Lato Emphasized 2", align: "center", marginBottom: 2, children: labels.noResults }),
                practitionersToRender.map(({ roleName, practitioners: practitioners2 }) => {
                  const selectedAmount = practitioners2.filter(({ isSelected, hidden }) => isSelected && !hidden).length;
                  const totalAmount = practitioners2.filter(({ hidden }) => !hidden).length;
                  if (!totalAmount) {
                    return null;
                  }
                  return /* @__PURE__ */ jsxs("div", { children: [
                    /* @__PURE__ */ jsx(SearchDivider, {}),
                    /* @__PURE__ */ jsx(Box, { m: 2, children: /* @__PURE__ */ jsxs(Typography, { variant: "Lato Emphasized 1", children: [
                      labels.toggles[roleName],
                      /* @__PURE__ */ jsx(RoleCount, { variant: "Lato Emphasized 2", children: `(${selectedAmount}/${totalAmount})` })
                    ] }) }),
                    practitioners2.map((practitioner) => {
                      const { avatar, isSelected, id, hidden } = practitioner;
                      if (hidden) {
                        return null;
                      }
                      return /* @__PURE__ */ jsx(
                        MenuItem,
                        {
                          avatar: {
                            ...avatar,
                            imageUrl: `${avatar.imageUrl}-/resize/32x/`
                          },
                          variant: "checkbox",
                          onClick: () => handlePractitionerSelect(practitioner),
                          selected: isSelected,
                          children: avatar.userName
                        },
                        id
                      );
                    })
                  ] }, roleName);
                })
              ] })
            ] })
          ] }),
          selectedStatuses && /* @__PURE__ */ jsxs(Accordion, { children: [
            /* @__PURE__ */ jsxs(AccordionSummary, { expandIcon: /* @__PURE__ */ jsx(ExpandMoreIcon, {}), "aria-controls": "panel2-content", id: "panel2-header", children: [
              /* @__PURE__ */ jsx(StatusTitle, { variant: "Lato Emphasized 1", children: labels.statuses.titles.statuses }),
              " ",
              statusSelectedCount ? /* @__PURE__ */ jsx(StatusCount, { variant: "Lato Caption Bold", children: statusSelectedCount }) : null
            ] }),
            /* @__PURE__ */ jsx(AccordionDetails, { children: selectedStatuses.map((status) => {
              return /* @__PURE__ */ jsx(
                MenuItem,
                {
                  variant: "checkbox",
                  onClick: () => {
                    handleStatusSelect(status);
                  },
                  selected: status.isSelected,
                  children: labels.statuses.types[status.status]
                },
                status.status
              );
            }) })
          ] })
        ] })
      }
    )
  ] });
};
export {
  PractitionerSelect
};
